import {LocalErrorLogDao} from "../database/dao/LocalErrorLog";


export class LocalErrorLogRepository {
    static async registerError(label: string, error: Error) {
        await LocalErrorLogDao.putError(label, error)
    }
}
